var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bonusProduct"},[_c('div',{staticClass:"card-header"},[_c('p',[_c('i',{staticClass:"el-icon-present"}),_vm._v("换新福利\n      "),_c('span',[_vm._v("环保补助金"+_vm._s(_vm.product.bonus_price)+"元")])]),_c('i',{staticClass:"el-icon-circle-check checkBonus"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }